<template>
  <DatePicker
    v-model="pickerDate"
    :range="selectRange"
    type="date"
    value-type="date"
    format="D MMMM YYYY"
    :clearable="false"
  >
    <template v-slot:header class="my=0 py=0">
      <v-checkbox
        v-model="selectRange"
        dense
        class="my=0 py=0"
        label="Несколько дней? Точно не известно?"
      ></v-checkbox>
      <v-text-field
        v-if="selectRange"
        v-model="date_title"
        dense
        placeholder="Лето, конец мая, видимо весна"
        @input="handleInput(pickerDate)"
      ></v-text-field>
    </template>
  </DatePicker>
</template>

<script>
import DatePicker from 'vue2-datepicker'

import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'
export default {
  components: {
    DatePicker
  },
  props: {
    dateRange: {
      type: Array,
      default: () => [null, new Date(), null]
    }
  },
  model: {
    prop: 'dateRange',
    event: 'dateRangeSubmit'
  },
  data() {
    return {
      pickerDate: this.dateRange[0]
        ? [this.dateRange[0], this.dateRange[1]]
        : this.dateRange[1],
      selectRange: !!this.dateRange[0],
      date_title: this.dateRange[2]
    }
  },
  watch: {
    selectRange: function(newVal) {
      if (newVal) {
        console.log('DATE RANGE:', this.dateRange)
        if (
          this.dateRange[0] == null ||
          this.dateRange[0] > this.dateRange[1]
        ) {
          //this.dateRange[0] = this.dateRange[1]
          this.handleInput([this.dateRange[1], this.dateRange[1]])
          this.pickerDate = [this.dateRange[1], this.dateRange[1]]
        } else {
          this.pickerDate = [this.dateRange[0], this.dateRange[1]]
        }
      } else {
        this.pickerDate = this.dateRange[1]
      }
    },
    pickerDate: function(newVal) {
      console.log('PICKER DATE', newVal)
      if (this.selectRange) {
        //this.dateRange = newVal
        this.handleInput(newVal)
      } else {
        //this.dateRange[1] = newVal
        this.handleInput([null, newVal])
      }
    }
  },
  methods: {
    handleInput(value) {
      console.log('EMIT', [...value, this.date_title])
      this.$emit('dateRangeSubmit', [...value, this.date_title])
    }
  }
}
</script>

<style>
.v-label {
  font-size: 9pt;
}
</style>
